module.exports = __webpack_public_path__ + "img/poster.f907052b.jpg";